import { Router } from '@angular/router';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { CenterLocation } from '../../modules/settings/super-admin/models/center-location';
import { CenterLocationService } from '../../modules/settings/super-admin/services/center-locations.service';
import { LocationConfirmDialogComponent } from '../location-confirm-dialog/location-confirm-dialog.component';
import { WarningIcons } from '../warning-dialogue/warning-icons.enum';
import { WarningDialogue } from '../warning-dialogue/warning.model';
import { ApplicationService } from '@core/services/application.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss'],
})
export class LocationSelectorComponent implements OnInit {
  @Output() currentLocation = new EventEmitter<CenterLocation>();

  selectedLocation = new CenterLocation(0);

  noLocation = new CenterLocation(0);

  disableSelect = new UntypedFormControl(false);

  data= this.centerLocationService.data$;
  isLoading: Observable<boolean>;
  roles;
  accessLocation: any[];

  isAdmin = false;

  constructor(
    private centerLocationService: CenterLocationService,
    private router: Router,
    private dialog: MatDialog,
    private appservice: ApplicationService
  ) {}

  ngOnInit() {

    this.appservice.hasRole('admin1').subscribe(role => this.isAdmin = role)

    this.isLoading = this.centerLocationService.isPending$;

    this.centerLocationService.getAllCenterLocations();

    if (sessionStorage.getItem('location') != null) {
      this.selectedLocation = JSON.parse(sessionStorage.getItem('location'));
      this.currentLocation.emit(this.selectedLocation);
    }
  }

  showLocationlist(locations) {
    this.accessLocation = [];

    if (!this.isAdmin) {
      locations.forEach((c) => {
        if (this.appservice.app.roles.find((d) => d == c.approle)) {
          this.accessLocation.push(c);
        }
      });
      if (this.accessLocation?.length == 1 && !this.selectedLocation?.name) {
        this.selectedLocation = this.accessLocation[0];
        this.currentLocation.emit(this.selectedLocation);
        let url = '';
        if (this.selectedLocation?.name) {
          this.appservice.setTab('dashboard');
          url = '/dashboard/general';
        } else {
          this.appservice.setTab('dashboard');
          url = '/dashboard/nolocation';
        }

        this.router.navigate([url]);
      }
      return of(this.accessLocation?.length > 1 ? true : false);
    } else {
      return of(true);
    }
  }

  checkRole(role) {
    //console.log(this.appservice.hasRole('supervisor'))
    if (!this.isAdmin) {
      const f = this.appservice.app.roles.find(
        (c) => c.toLowerCase() == role.toLowerCase()
      );
      if (f?.length) return true;
      else return false;
    } else {
      return true;
    }
  }

  setLocation(location: CenterLocation) {
    if (
      location?.name !== this.appservice.app.centerLocation?.name &&
      JSON.parse(sessionStorage.getItem('location'))?.name !== location?.name
    ) {
      const warningDialogue = new WarningDialogue(
        'Confirmation',
        'Changing location will result in losing any changes not saved. Do you wish to continue?',
        'Continue',
        'Cancel',
        WarningIcons.STOP
      );

      const dialogRef = this.dialog.open(LocationConfirmDialogComponent, {
        width: '640px',
        data: warningDialogue,
      });

      dialogRef.afterClosed().subscribe((newData) => {
        if (newData) {
          this.selectedLocation = location;
          this.currentLocation.emit(this.selectedLocation);
          let url = '';
          if (location?.name) {
            this.appservice.setTab('dashboard');
            url = '/dashboard/general';
          } else {
            this.appservice.setTab('dashboard');
            url = '/dashboard/nolocation';
          }

          this.router.navigate([url]);
        }
      });
    }
  }

  createLocation() {
    this.router.navigate(['dashboard', 'settings', 'Miscellaneous']);
  }
}
